import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  changeItemQuantity,
  removeItem,
  deleteLocalOrder,
  removeItemCreateKot,
  setDiscount,
  setOtherCharges,
  updateOrderDiscountSocket,
  confirmOrder,
  updateOrder,
  setKOTitemsData,
  setOrderConfermation,
  calculateKOT,
  setKOTinSocket,
} from "../../../redux/action/orderActions";
import {
  changeItemQuantityOffline,
  removeItemOffline,
  deleteLocalOrderOffline,
} from "../../../redux/action/offlineDataActions";
import { CURRENCY, ITEMSTATUS } from "../../../contants";
import calculateOrderTotals from "../../../helpers/calculateOrderTotals";
import roundOffTotal from "../../../helpers/roundOffTotal";
import PaymentSettleModal from "../../../components/common/Modals/PaymentSettleModal";
import OrderConfirmModal from "../../../components/common/Modals/OrderConfirmModal";
import { setPrintData } from "../../../redux/action/utilActions";
import { uuid } from "uuidv4";
import CustomerDetailsAccordion from "../components/CustomerDetailsAccordion";
import OrderItemsList, { getBgColor as getItemBgColor } from "../components/OrderItemsList";
import OrderSummary from "../components/OrderSummary";
import ActionButtons from "../components/ActionButtons";
import haptics from "../../../helpers/haptics";

export function parseFloat2Decimals(value) {
  return parseFloat(parseFloat(value).toFixed(2));
}

const calculateDiscountPercentage = (grandTotal, percent) => {
  let result = (percent * grandTotal) / 100;
  return parseFloat(result.toFixed(2));
};

const MobileCart = ({
  isOpen,
  onClose,
  activeOrder,
  handleKot,
  handleCustomerForm,
}) => {
  const dispatch = useDispatch();
  const { isOnline, isAppOffline } = useSelector(
    (state) => state.networkStatus
  );
  const { tables } = useSelector((state) => state.branch);
  const { id: userId, cgst, sgst, name, restaurantId, branchId, branchCode } = useSelector((state) => state.user);
  const {
    enableKOT,
    enablePrinting,
    enableKDS,
    lowerRoundOff,
    upperRoundOff,
    standardRoundOff,
    exclusiveGST,
  } = useSelector((state) => state.util);
  const { activeOrders, lastOrderNumber } = useSelector((state) => state.order);
  const { itemAvailability } = useSelector((state) => state.common);
  const isElectron = window?.api?.isElectron;

  const [discountValue, setDiscountValue] = useState("");
  const [discountPercent, setDiscountPercent] = useState("");
  const [otherChargesValue, setOtherChargesValue] = useState("");
  const [settleOpen, setSettleOpen] = useState();
  const [prePrintOpen, setPrePrintOpen] = useState();
  const [print, setPrintState] = useState();
  const [isDetailsAccordionOpen, setIsDetailsAccordionOpen] = useState(false);
  const [customerNameState, setCustomerNameState] = useState("");
  const [customerPhoneState, setCustomerPhoneState] = useState("");
  const [remarksState, setRemarksState] = useState("");

  // Extract order data
  const { orderItems = [], totalAmount = 0, KOTS = [] } = activeOrder || {};

  // Group order items by KOT (same as desktop)
  const getGroupedOrderItems = () => {
    if (!activeOrder || !activeOrder.KOTS) return [];
    
    return activeOrder.KOTS.map((kot, index) => ({
      kotNumber: kot.kotNumber,
      kotIndex: index,
      items: kot.orderItems || [],
    }));
  };

  const orderItemsGrouped = getGroupedOrderItems();

  let tableType = tables.filter((table) => {
    return table?.tableNumber === activeOrder?.tableNumber;
  });
  const tableKind = tableType[0]?.tableType;

  if (activeOrder?.orderType === "Home Delivery") {
    tableType = [{ tableType: "Online" }];
  }

  const roundOffType = lowerRoundOff
    ? "lowerRoundOff"
    : upperRoundOff
    ? "upperRoundOff"
    : "standardRoundOff";
  const discount = activeOrder?.discount || 0;
  const otherCharges = activeOrder?.otherCharges || 0;
  const customerName = activeOrder?.customerName;
  const customerMobile = activeOrder?.customerMobile;
  const remarks = activeOrder?.remarks;

  const orderIndex = activeOrders.findIndex(order => order.refId === activeOrder?.refId);

  // All hooks must be called before any early returns
  React.useEffect(() => {
    setDiscountValue(discount === 0 ? "" : discount);
    setOtherChargesValue(otherCharges === 0 ? "" : otherCharges);
  }, [discount, otherCharges]);

  // Sync customer details with active order
  React.useEffect(() => {
    if (activeOrder) {
      setCustomerNameState(activeOrder.customerName || "");
      setCustomerPhoneState(activeOrder.customerMobile || "");
    }
  }, [activeOrder?.refId, activeOrder?.customerName, activeOrder?.customerMobile]);

  const getMealNameByIST = (currentIST = new Date()) => {
    const offsetMs = 5.5 * 60 * 60 * 1000;

    const foundMeal = itemAvailability.find(meal => {
      const startIST = new Date(new Date(meal.mealStartTime).getTime() + offsetMs);
      const endIST = new Date(new Date(meal.mealEndTime).getTime() + offsetMs);
      return currentIST >= startIST && currentIST <= endIST;
    });

    if (foundMeal) return foundMeal.mealName;

    const hours = currentIST.getHours();
    return hours >= 3 && hours < 15 ? "Lunch" : "Dinner";
  };

  const getPaymentType = (types) => {
    return types
      .map((t) => {
        return t.paymentMethodType;
      })
      .join(", ");
  };

  // Early return after all hooks
  if (!activeOrder) {
    return (
      <>
        <div
          className={`mobile-cart-overlay ${isOpen ? "open" : ""}`}
          onClick={onClose}
        ></div>
        <div className={`mobile-cart-drawer ${isOpen ? "open" : ""}`}>
          <div className="d-flex justify-content-between align-items-center p-1 text-white mobile-cart-header">
            <button
              className="btn border-0 text-dark p-0 mobile-cart-close-btn"
              onClick={onClose}
            >
              <i className="mdi mdi-close"></i>
            </button>
          </div>
          <div className="flex-fill overflow-auto p-2">
            <div className="d-flex flex-column align-items-center justify-content-center text-muted h-100">
              <i className="mdi mdi-cart-outline mobile-cart-empty-icon"></i>
              <p className="mb-0">Your cart is empty</p>
              <small className="mt-1">Add items to get started</small>
            </div>
          </div>
        </div>
      </>
    );
  }

  // Handle quantity change (matches desktop pattern)
  const handleQuantityChange = (item, kotIndex, change) => {
    haptics.light();
    // Prevent quantity from going below 1
    const newQuantity = item.quantity + change;
    if (newQuantity < 1) {
      return;
    }

    if ((isAppOffline || !isOnline) && isElectron) {
      dispatch(
        changeItemQuantityOffline({
          quantity: change,
          itemId: item.itemId,
          tableType: tableKind,
        })
      );
    } else {
      dispatch(
        changeItemQuantity({
          quantity: change,
          itemId: item.itemId,
          tableType: tableKind,
          index: kotIndex,
          item: item,
        })
      );
    }
  };

  const handleDeleteItem = (item, kotNumber, kotIndex) => {
    haptics.error();
    const { restaurantId, branchId } = item;

    if ((isAppOffline || !isOnline) && isElectron) {
      dispatch(removeItemOffline(item.itemId));
    } else {
      dispatch(removeItem(item.id, kotIndex));
      if (kotNumber !== undefined) {
        dispatch(
          removeItemCreateKot({
            restaurantId,
            branchId,
            userId: userId,
            kotNumber,
            item,
            isDeleted: true,
          })
        );
      }
    }
  };

  const getOrderTotals = () => {
    if (!activeOrder) return null;
    return calculateOrderTotals(
      activeOrder,
      cgst,
      sgst,
      otherCharges,
      discount,
      tableKind,
      exclusiveGST
    );
  };

  const handleCloseSettleModal = () => {
    setSettleOpen();
  };

  const handleOpenSettleModal = (data) => {
    setSettleOpen(data);
  };

  const calKOT = () => {
    return calculateKOT({
      active: activeOrder,
      lastOrderNumber,
      activeOrders,
    });
  };

  const printKOT = (customerData) => {
    const { kotItems, kotData } = calKOT();

    if (kotItems?.length > 0 && enableKOT) {
      kotItems.forEach((dataitem) => {
        const foundmyItem = activeOrder.orderItems.findIndex(
          (item) => item.itemId === dataitem.itemId
        );
        activeOrder.orderItems[foundmyItem].itemStatus = ITEMSTATUS[1].key;
        activeOrder.orderItems[foundmyItem].itemStatusId = ITEMSTATUS[1].value;
        activeOrder.orderItems[foundmyItem].kotQuantity =
          activeOrder.orderItems[foundmyItem].quantity;
      });
      activeOrder.KOTS.push({
        id: uuid(),
        status: ITEMSTATUS[1].key,
        statusId: ITEMSTATUS[1].value,
        orderItems: kotItems,
      });

      if (!isAppOffline && isOnline) {
        setKOTinSocket(activeOrder.refId, activeOrder);
      }
    }
  };

  // Handle Print KOT Button
  const handlePrintKOT = async () => {
    if (!activeOrder) {
      return alert("No active order");
    }
    await handleKot(tableKind, true);
  };

  // Handle Pre Print (Bill without printing)
  const handlePrePrintOpen = (printFlag) => {
    setPrintState(printFlag);
    if (!activeOrder) {
      return alert("No active order");
    }
    if (activeOrder.orderItems.length === 0) {
      return alert("No item selected");
    }
    
    if (activeOrder.orderItems.length > 0) {
      printKOT({
        customerData: {
          customerName: customerName,
          customerMobile: customerMobile,
        },
      });
    }
    setPrePrintOpen(true);
    if (customerName || customerMobile) {
      handleConfirmOrder();
    }
  };

  // Handle Bill Print Button
  const handleBillPrint = () => {
    handlePrePrintOpen(true);
  };

  const handleConfirmOrder = (paymentData, others, cb) => {
    const customerData = handleCustomerForm();

    let orderdata = {
      ...activeOrder,
      ...getOrderTotals(),
      otherCharges: parseFloat2Decimals(getOrderTotals()?.otherCharges ?? 0),
      discount: parseFloat2Decimals(getOrderTotals()?.discount ?? 0),
      itemsTotal: roundOffTotal(getOrderTotals().gstItemsTotal, roundOffType),
      grandTotal: roundOffTotal(getOrderTotals().grandTotal, roundOffType),
      orderItems: activeOrder.orderItems,
      orderBy: name,

      paymentType: undefined,
      paymentTypeId: undefined,
      tableNumber: activeOrder.tableNumber,
      tableId: activeOrder._id,
      restaurantId,
      branchId,
      orderNumber: lastOrderNumber + (activeOrders.length - orderIndex),
      branchCode: branchCode,
      orderType: activeOrder.orderType,
      orderTypeId: activeOrder.orderTypeId,

      isPaid: false,
      isBillPrinted: true,

      ...customerData,
      ...paymentData,

      ...others,
    };
    setPrePrintOpen(false);
    if (!isAppOffline && isOnline) {
      dispatch(
        confirmOrder(
          orderdata,
          (data) => {
            setOtherChargesValue(0);
            setDiscountValue(0);
            cb && cb();
            if(print){
              dispatch(setPrintData({ ...(data.data.data), printId: uuid() }));
            }
          },
          tableType
        )
      );
      dispatch(setOrderConfermation(activeOrder));
    }
  };

  // Handle Settle Click
  const handleSettleClick = () => {
    haptics.success();
    if (!activeOrder) {
      return alert("No active order");
    }
    if (activeOrder.orderItems.length === 0) {
      return alert("No item selected");
    }

    const customerData = handleCustomerForm();
    let orderdata = {
      ...activeOrder,
      ...getOrderTotals(),
      otherCharges: parseFloat2Decimals(getOrderTotals()?.otherCharges ?? 0),
      discount: parseFloat2Decimals(getOrderTotals()?.discount ?? 0),
      itemsTotal: roundOffTotal(getOrderTotals().gstItemsTotal, roundOffType),
      grandTotal: roundOffTotal(getOrderTotals().grandTotal, roundOffType),
      orderItems: activeOrder.orderItems,
      orderBy: name,

      paymentType: undefined,
      paymentTypeId: undefined,
      tableNumber: activeOrder.tableNumber,
      tableId: activeOrder._id,
      restaurantId,
      branchId,
      orderNumber: lastOrderNumber + (activeOrders.length - orderIndex),
      branchCode: branchCode,
      isPaid: false,
      isBillPrinted: true,

      ...customerData,

      ...(activeOrder?.isEdited && {
        isEdited: true,
        isOrderConfirmed: true,
        isPaid: true,
        _id: activeOrder.id || activeOrder._id,
      }),
    };

    handleOpenSettleModal(orderdata);
  };

  const onSettlePayment = (paymentData, customerData) => {
    if (isAppOffline || !isOnline) {
      window.api.createOrderOffline({
        ...settleOpen,
        ...paymentData,
        ...customerData,
        paymentType: getPaymentType(paymentData.paymentMethods),
        orderStatus: "completed",
        isEdited: false,
        isOrderConfirmed: true,
        isPaid: true,
        branchOrderNumber: activeOrder.branchOrderNumber,
      });

      dispatch(deleteLocalOrderOffline(settleOpen.refId));
      setOtherChargesValue(0);
      setDiscountValue(0);
      setSettleOpen();
      onClose();
    } else {
      if (!isAppOffline && isOnline && settleOpen.isOrderConfirmed) {
        dispatch(
          updateOrder(
            {
              ...settleOpen,
              ...paymentData,
              ...customerData,
              paymentType: getPaymentType(paymentData.paymentMethods),
              orderStatus: "completed",
              isEdited: false,
              isOrderConfirmed: true,
              shift:  getMealNameByIST(),
              isPaid: true,
              _id: activeOrder.id || activeOrder._id,
            },
            (data) => {
              setOtherChargesValue(0);
              setDiscountValue(0);
              dispatch(deleteLocalOrder(settleOpen.refId));
              setSettleOpen();
              onClose();
            }
          )
        );
      } else {
        dispatch(
          confirmOrder(
            {
              ...settleOpen,
              ...paymentData,
              ...customerData,
              paymentType: getPaymentType(paymentData.paymentMethods),
              orderStatus: "completed",
              isEdited: false,
              shift:  getMealNameByIST(),
              isOrderConfirmed: true,
              isPaid: true,
            },
            (data) => {
              setOtherChargesValue(0);
              setDiscountValue(0);
              dispatch(deleteLocalOrder(settleOpen.refId));
              setSettleOpen();
              onClose();
            }
          )
        );
      }
    }
  };

  return (
    <>
      <div
        className={`mobile-cart-overlay ${isOpen ? "open" : ""}`}
        onClick={onClose}
      ></div>
      <div className={`mobile-cart-drawer ${isOpen ? "open" : ""}`}>
        {/* Fixed Header - Same as Desktop */}
        <div className="mobile-cart-header bg-white border-bottom p-3">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h5 className="font-weight-bold mb-2 mt-0 text-dark">Order Summary</h5>
              {activeOrder && (
                <div className="d-flex align-items-center gap-2 flex-wrap">
                  <span className="badge badge-primary">
                    <i className="mdi mdi-table-furniture"></i>{" "}
                    {activeOrder.tableNumber || activeOrder.orderType}
                  </span>
                  {activeOrder.branchOrderNumber && (
                    <span className="badge badge-light">
                      #{activeOrder.branchOrderNumber}
                    </span>
                  )}
                </div>
              )}
            </div>
            <button
              className="btn border-0 text-dark p-0"
              onClick={onClose}
              style={{ fontSize: "24px" }}
            >
              <i className="mdi mdi-close"></i>
            </button>
          </div>
        </div>

        {/* Scrollable Content Area - Only Order Items */}
        <div className="mobile-cart-content flex-grow-1 overflow-auto bg-white">
          {/* Order Items List - Using Same Component as Desktop */}
          <OrderItemsList
            orderItemsGrouped={orderItemsGrouped}
            handleQuantityChange={handleQuantityChange}
            handleDeleteItem={handleDeleteItem}
            onToggleDetailsAccordion={() => setIsDetailsAccordionOpen(!isDetailsAccordionOpen)}
            isDetailsAccordionOpen={isDetailsAccordionOpen}
          />
        </div>

        {/* Fixed Footer - Accordion, Totals and Actions (Same as Desktop) */}
        <div className="mobile-cart-footer bg-white border-top">
          {/* Customer Details Accordion - Fixed at Bottom, Opens Upward */}
          <CustomerDetailsAccordion
            isOpen={isDetailsAccordionOpen}
            toggleAccordion={() => setIsDetailsAccordionOpen(!isDetailsAccordionOpen)}
            customerName={customerNameState}
            setCustomerName={setCustomerNameState}
            customerPhone={customerPhoneState}
            setCustomerPhone={setCustomerPhoneState}
            otherCharges={otherCharges}
            setOtherCharges={setOtherChargesValue}
            discountPercent={discountPercent}
            setDiscountPercent={setDiscountPercent}
            discountAmount={discountValue}
            setDiscountAmount={setDiscountValue}
            currentOrder={activeOrder}
            getData={getOrderTotals}
            remarks={remarksState}
            setRemarks={setRemarksState}
          />

          {/* Order Summary - Subtotal, GST, Discount, etc. */}
          <OrderSummary
            currentOrder={activeOrder}
            orderData={getOrderTotals()}
            cgst={cgst}
            sgst={sgst}
          />

          {/* Action Buttons with Grand Total in Settle Button */}
          <ActionButtons
            currentOrder={activeOrder}
            orderItemsGrouped={orderItemsGrouped}
            handleKot={(tableType, print) => {
              if (print) {
                handlePrintKOT();
              } else {
                handleKot(tableKind);
              }
            }}
            tableType={tableType}
            finalGrandTotal={roundOffTotal(getOrderTotals().grandTotal || 0, roundOffType) || 0}
            onBillClick={() => handlePrePrintOpen(false)}
            onPrintBillClick={() => handleBillPrint()}
            onSettleClick={() => handleSettleClick()}
          />
        </div>
      </div>

      {/* Payment Settle Modal */}
      {settleOpen && (
        <PaymentSettleModal
          open={settleOpen}
          data={settleOpen}
          title={""}
          onClose={() => handleCloseSettleModal()}
          onSubmit={(data, customer) => onSettlePayment(data, customer)}
          customerName={customerName}
          customerMobile={customerMobile}
        />
      )}

      {/* Order Confirm Modal */}
      {prePrintOpen && !customerName && !customerMobile && (
        <OrderConfirmModal
          open={prePrintOpen}
          text={`Grand total : ${CURRENCY} ${(roundOffTotal(getOrderTotals().grandTotal || 0, roundOffType) || 0).toFixed(2)}`}
          onConfirm={() => handleConfirmOrder()}
          onCancel={() => setPrePrintOpen()}
          customerName={customerName}
          customerMobile={customerMobile}
        />
      )}
    </>
  );
};

export default MobileCart;